import { HTTP_INTERCEPTORS, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { EffectsModule } from '@ngrx/effects';
import { RouterStateSerializer, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

import { AgGridModule } from '@ag-grid-community/angular';
import { AuthGuard } from '@auth/auth-guard.service';
import { AuthModule } from '@auth/auth.module';
import { AuthService } from '@auth/auth.service';
import { AuthEffects } from '@auth/store/auth.effects';
import { DataService } from '@data/data.service';
import { DataEffects } from '@data/store/data.effects';
import { MainModule } from '@main/main.module';
import { SharedModule } from '@main/shared.module';
import { ReportService } from '@reports/report.service';
import { metaReducers, reducers } from '@store/app.reducers';
import { CustomSerializer } from '@store/custom-serializer';

import { HttpErrorInterceptor, HttpTimeoutInterceptor, HttpXsrfInterceptor } from '@util/http-interceptors';

import { environment } from '@environment';

import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';

@NgModule({
  declarations: [AppComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    AuthModule,
    MainModule,
    AgGridModule,
    HttpClientModule,
    HttpClientXsrfModule.withOptions({
      cookieName: environment.xsrfTokenCookie,
      headerName: environment.xsrfTokenHeader,
    }),
    SharedModule,
    StoreModule.forRoot(reducers, {
      runtimeChecks: {
        strictStateImmutability: false,
        strictActionImmutability: false,
        strictStateSerializability: false,
        strictActionSerializability: false,
      },
      metaReducers,
    }),
    EffectsModule.forRoot([AuthEffects, DataEffects]),
    StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
    !environment.production ? StoreDevtoolsModule.instrument() : [],
  ],
  providers: [
    AuthGuard,
    AuthService,
    DataService,
    ReportService,
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpXsrfInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpTimeoutInterceptor, multi: true },
    { provide: RouterStateSerializer, useClass: CustomSerializer },
  ],
  exports: [SharedModule],
  bootstrap: [AppComponent],
})
export class AppModule {}
